import styled from 'styled-components';
import { Body2, Caption } from 'ui/theme';

import { TableCell } from 'ui/tableCell';

export const Cell = styled(TableCell)`
  padding-bottom: ${({ theme }) => theme.spacing.values.plusHalf};
  padding-top: ${({ theme }) => theme.spacing.values.plusHalf};
  vertical-align: middle;
`;

export const Body2LessMargin = styled(Body2)`
  margin-bottom: ${({ theme }) => theme.spacing.values.quarter};
`;

export const InlineFlex = styled.div`
  display: inline-flex;
`;

export const CaptionSecondary = styled(Caption)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;
